import { ArrowDownIcon, ArrowUpIcon } from "lucide-react";

import { Text } from "@/components";

import { cn } from "@/lib/utils";

// How far the median sits from the 12h target, as the pill under the number.
export const TtfsGoalDelta = ({
  hoursOffGoal,
  textClass,
}: {
  // Null when nothing was screened in the period.
  hoursOffGoal: number | null;
  textClass: string;
}) => {
  /* Render */
  const render = () => {
    if (hoursOffGoal === null) {
      return (
        <Text className={cn("truncate text-[10px] font-semibold", textClass)}>
          No screens this period
        </Text>
      );
    }

    if (hoursOffGoal === 0) {
      return (
        <Text className={cn("truncate text-[10px] font-semibold", textClass)}>
          On target
        </Text>
      );
    }

    const isOverGoal = hoursOffGoal > 0;
    const DeltaIcon = isOverGoal ? ArrowUpIcon : ArrowDownIcon;
    return (
      <>
        <DeltaIcon className={cn("h-3 w-3 shrink-0", textClass)} />
        <Text className={cn("truncate text-[10px] font-semibold", textClass)}>
          {Math.abs(hoursOffGoal).toString()} hrs{" "}
          {isOverGoal ? "over" : "under"} target
        </Text>
      </>
    );
  };

  return render();
};
